// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1Y2gZ","select":"Header_select__1zYzG","clinic":"Header_clinic__3Hk-3"};